import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=1856bbf4&"
import script from "./TypeList.vue?vue&type=script&lang=ts&"
export * from "./TypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports